const menuTrigger = document.querySelector('#open-mobile-menu');
const mobileMenu = document.querySelector('.mobile-menu-navigation');

if (menuTrigger) {
  menuTrigger.addEventListener('click', function () {
    
    if (menuTrigger.classList.contains('active')) {
      menuTrigger.classList.remove('active');
      mobileMenu.classList.remove('active');
    } else {
      menuTrigger.classList.add('active');
      mobileMenu.classList.add('active');
    }
    
  });
}

let scrollPosition = window.scrollY;
const QF_Header = document.querySelector('#shopify-section-header');

window.addEventListener('scroll', function() {
  var scrollPosition = window.scrollY;
  var breakpoint = 767.5;

  if (window.innerWidth < breakpoint) {
    if (scrollPosition >= 26) {
      QF_Header.classList.add('is-scrolled');
    } else {
      QF_Header.classList.remove('is-scrolled');
    }
  } else {
    if (scrollPosition >= 37) {
      QF_Header.classList.add('is-scrolled');
    } else {
      QF_Header.classList.remove('is-scrolled');
    }
  }
});
